export default __webpack_public_path__ + "images/0e8e46e1806468b057159cd884babfae-4-01.svg";